import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="header-container">
      <div className="header-inner">
        {/* Logo and Tagline */}
        <div className="logo-section" onClick={() => navigate('/')}>
          <img
            src="/assets/logo.png" // Path to your logo image
            alt="Ambivert Logo"
            className="logo-img"
          />
          <div className="logo-text">
            <div className="logo-title">ambivert.ai</div>
            <div className="logo-tagline">intelligence meets balance</div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="navigation">
          <Link className="nav-item" to="/inquiries">
            AI Use Cases
          </Link>
          <Link className="nav-item" to="/submit-inquiry">
            Submit Inquiry
          </Link>
          <Link className="nav-item" to="/partners">
            For Partners
          </Link>
          <Link className="nav-item" to="/chat">
            Chat
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;